import CompanyParticipationChart from '../SocioDemographicTab/CompanyParticipationChart';

import { Content02, Data012, Row011 } from './styles';

interface CompanyParticipationTabProps {
  companyParticipations: {
    description: string;
    quantity: number;
    percentage: number;
  }[];
}

const CompanyParticipationTab = ({
  companyParticipations,
}: CompanyParticipationTabProps) => {
  return (
    <Content02>
      <Row011>
        <Data012>
          <CompanyParticipationChart
            companyParticipations={companyParticipations || []}
          />
        </Data012>
      </Row011>
    </Content02>
  );
};

export default CompanyParticipationTab;
